import { PremiumBackground } from '../effects/PremiumBackground';
import React from 'react';
import { XCircle, CheckCircle2, ArrowDown, GitCommit } from 'lucide-react';
export interface ApproachBridgeProps {
  id?: string;
}

export const ApproachBridge: React.FC<ApproachBridgeProps> = ({ id = 'approach' }) => {
  const comparisonRows = [
    {
      criterion: 'Роль и компетенция',
      broker: 'Комиссионный риелтор / брокер готового бизнеса. Не понимает медицинских лицензий и ст. 54.1.',
      spDesk: 'Институциональный M&A-архитектор: бывшие инвестиционные банкиры, налоговые литигаторы и мед-аудиторы.',
    },
    {
      criterion: 'Мотивация и логика оценки',
      broker: 'Быстрее скинуть цену на 30–40%, чтобы получить свою комиссию 5% от любой суммы закрытия.',
      spDesk: 'Максимизация мультипликатора (с 4.0x до 7.5x EBITDA). Доход S&P напрямую привязан к премии за институциональный статус.',
    },
    {
      criterion: 'Конфиденциальность данных',
      broker: 'Публикует фото интерьера в Telegram-каналах и на Авито. О продаже сразу узнают врачи и арендодатель.',
      spDesk: 'Четыре шлюза изоляции. Слепой тизер. Доступ к Data Room открывается только после скоринга капитала и Mutual NDA.',
    },
    {
      criterion: 'Финансовый пакет (P&L и EBITDA)',
      broker: '«Словно из блокнота»: берет цифры со слов, которые рассыпаются при первой же проверке аудиторами покупателя.',
      spDesk: 'Нормализация EBITDA по методологии Big-4. Выделение разовых CapEx, подтверждение LTV пациентов и юнит-экономики кресел.',
    },
    {
      criterion: 'Налоговые и правовые риски',
      broker: 'Игнорирует дробление. Когда покупатель требует дисконт 100 млн ₽, разводит руками.',
      spDesk: 'Санация структуры до выхода на рынок: перевод на белые протоколы, защита договоров аренды на 7+ лет, чистка баланса.',
    },
    {
      criterion: 'Пул покупателей',
      broker: 'Случайные физические лица без подтвержденного капитала, требующие рассрочки на 5 лет.',
      spDesk: 'Прямые контакты с M&A-директорами топ-10 федеральных медицинских холдингов и управляющими партнерами PE-фондов.',
    },
  ];

  return (
    <section
      id={id}
      aria-label="Deal Design vs Brokerage: Сравнение подходов к сделке"
      className="relative w-full bg-[#FAF8F5] text-[#141416] py-24 md:py-32 border-t border-b border-[#DCD5C8] overflow-hidden"
    >
      {/* ТАКТИЛЬНЫЙ МАКРО-РЕЛЬЕФ */}
      <PremiumBackground variant={7} />

      
      

      
      

      {/* Light subtle archival paper gradient */}
      <div className="absolute top-0 left-0 right-0 h-48 bg-gradient-to-b from-[#F2EDE4]/60 to-transparent pointer-events-none" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="max-w-4xl mb-14 flex flex-col gap-6">
          <div 
            className="luxury-eyebrow text-[#8C6D37] flex items-center gap-2.5 font-bold tracking-[0.2em] uppercase"
            
          >
            <span className="w-1.5 h-1.5 rounded-none bg-[#8C6D37] shadow-[0_1px_1px_rgba(0,0,0,0.3)]" />
            ЭТАЖ 5 // СМЕНА ПАРАДИГМЫ // ИНСТИТУЦИОНАЛЬНЫЙ СТАНДАРТ
          </div>
          
          <h2 
            className="text-3xl sm:text-5xl lg:text-[54px] font-serif font-semibold text-[#141416] tracking-[-0.025em] leading-[1.08] select-none"
            
          >
            Deal Design против Обычного Брокериджа: <br />
            <span 
              className="text-[#8C6D37] italic font-serif"
              
            >
              почему институциональные сделки готовятся иначе
            </span>
          </h2>
          
          <p 
            className="text-[16px] sm:text-[17px] text-[#2D3748] leading-[1.65] font-sans font-normal max-w-3xl border-l-[4px] border-[#8C6D37] pl-6 mt-4"
            
          >
            В сделках свыше 50 млн рублей не работает модель «повесить объявление и ждать звонка». 
            Институциональные покупатели покупают управляемый денежный поток, защищенный от субсидиарной ответственности.
          </p>
        </div>

        {/* Comparison Table with Deep Chamfer & Inset Deboss */}
        <div 
          className="bg-[#FAF8F5]/95 rounded-[3px] overflow-x-auto mb-10 border border-[#DCD5C8] relative"
          style={{
            boxShadow: 'inset 0 1.5px 0 rgba(255,255,255,0.98), inset 0 -1.5px 0 rgba(45,35,20,0.06), 0 16px 40px -8px rgba(45,35,20,0.08)'
          }}
        >
          <div className="min-w-[720px] relative z-10">
            <div className="grid grid-cols-12 bg-[#F2EDE4] border-b border-[#DCD5C8] text-[11px] font-mono">
              <div 
                className="col-span-3 p-5 text-[#64748B] uppercase tracking-[0.1em] font-bold"
                
              >
                КРИТЕРИЙ СДЕЛКИ
              </div>
              <div 
                className="col-span-4 p-5 text-[#64748B] border-l border-r border-[#DCD5C8] uppercase tracking-[0.1em] font-bold"
                
              >
                ОБЫЧНЫЕ БРОКЕРЫ (КУСТАРНЫЙ РЫНОК)
              </div>
              <div 
                className="col-span-5 p-5 flex items-center justify-between bg-[#8C6D37]/15 border-l border-[#8C6D37]/30"
                style={{
                  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.6)'
                }}
              >
                <span 
                  className="text-[#8C6D37] font-bold uppercase tracking-[0.1em]"
                  
                >
                  S&amp;P M&amp;A DESK (DEAL DESIGN)
                </span>
                <span 
                  className="luxury-eyebrow text-[#8C6D37] font-bold tracking-widest text-[9px] px-2 py-0.5 bg-[#8C6D37]/10 rounded-[2px] border border-[#8C6D37]/30"
                  
                >
                  SWISS STANDARD
                </span>
              </div>
            </div>

            <div className="divide-y divide-[#DCD5C8]">
              {comparisonRows.map((row, idx) => (
                <div 
                  key={idx} 
                  className="grid grid-cols-12 text-[13px] hover:bg-[#F5EFE6]/60 transition-colors duration-200"
                >
                  <div 
                    className="col-span-3 p-5 font-bold text-[#141416] flex items-center font-sans bg-[#FAF7F2]"
                    
                  >
                    {row.criterion}
                  </div>
                  <div className="col-span-4 p-5 text-[#475569] border-l border-r border-[#DCD5C8] flex items-start gap-3 font-normal font-sans">
                    <XCircle className="w-4 h-4 text-[#8C6D37] shrink-0 mt-0.5 opacity-80" />
                    <span className="leading-relaxed" >
                      {row.broker}
                    </span>
                  </div>
                  <div className="col-span-5 p-5 bg-[#8C6D37]/5 flex items-start gap-3 font-sans border-l border-[#8C6D37]/20">
                    <CheckCircle2 className="w-4 h-4 text-[#8C6D37] shrink-0 mt-0.5" />
                    <span 
                      className="font-semibold text-[#141416] leading-relaxed"
                      
                    >
                      {row.spDesk}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* =========================================================================
            5. НАВИГАТОР ПЕРЕХОДА К ЭТАЖУ 6
            ========================================================================= */}
        <div className="flex justify-center pt-4">
          <a 
            href="#diagnostic" 
            className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.15em] font-semibold transition-all py-3 px-6 bg-[#FAF8F5] hover:bg-[#F2EDE4] border border-[#DCD5C8] rounded-[2px] text-[#8C6D37] hover:text-[#141416]"
            style={{
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 2px 6px rgba(45,35,20,0.05)'
            }}
          >
            <span>[ ПЕРЕЙТИ НА ЭТАЖ 6: ОЦЕНКА ГОТОВНОСТИ К СДЕЛКЕ ↓ ]</span>
          </a>
        </div>
      </div>
    </section>
  );
};

